<template>
  <div class="papery-upload">

    <!-- 必选还是可选 -->
    <template v-for="(material, index) in applicant.material[isRequired ? config.required.attr: config.optional.attr]">
      <div class="panel" v-if="material.attr === 1" :key="index">

        <!-- 左边icon -->
        <div class="icon-box">

          <!-- 有错误消息就是资料不完善 -->
          <img src="../../assets/imgs/passed.png" alt="passed" v-if="!(material.express.length > 0 && material.express[0].memo && material.express[0].paper_status === 4)">
          <img src="../../assets/imgs/not-pass.png" alt="not-pass" v-else>
        </div>

        <div class="content">

          <!-- 名字 -->
          <div class="header">
            <div class="name-box"><span class="name" v-text="material.paper_name"></span><span class="required" v-if="isRequired">*</span></div>
            <div class="handle-box">
              <a @click="showImage(material.sample)" class="el-button el-button--primary" v-if="material.sample && material.sample.length > 0">查看样例</a>
              <a :href="material.template" class="el-button el-button--primary is-plain" v-if="material.template">下载模板</a>
            </div>
          </div>

          <!-- 注意事项 -->
          <attention class="attention-box" :attention="material.attention"></attention>

          <!-- 资料不完善备注 -->
          <memo 
            class="memo" 
            v-if="material.express.length > 0 && material.express[0].memo && material.express[0].paper_status === 4" 
            :memo-content="material.express[0].memo" 
            :invalid-file-list="material.express[0].invalid_file_set">
          </memo>
        </div>
      </div>
    </template>

    <!-- 多图预览弹窗 -->
    <multi-image-preview v-model="multiImagePreviewOpen" :multiImageArray="multiImageArray"></multi-image-preview>
  </div>
</template>

<script>
import attention from '../upload/attention.vue';
import memo from '../upload/memo.vue';
import multiImagePreview from '../../components/common/multi-image-preview';

export default {
  name: 'uploadPaperyMaterial',
  components: {
    attention,
    memo,
    multiImagePreview,
  },
  props: {
    applicant: {
      type: Object,
      default() {
        return {};
      },
    },
    isRequired: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  data() {
    return {
      config: {
        required: {
          title: '必需资料',
          attr: 'material_required',
        },
        optional: {
          title: '辅助资料',
          attr: 'material_optional',
        },
      },
      multiImagePreviewOpen: false,
      multiImageArray: [],
    };
  },
  methods: {
    // 打开多图预览弹窗
    showImage(data) {
      this.multiImagePreviewOpen = true;

      // 后端部分接口资料样例 sample 返回的仍然是字符串，而不是数组，这里先做一个兼容处理。
      if (typeof data === 'string') {
        const buildData = [];
        buildData.push(data);
        this.multiImageArray = buildData;
      } else {
        this.multiImageArray = data;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.papery-upload {
  background-color: #fff;
  .panel {
    display: flex;
    padding: 20px 30px;
    .icon-box {
      display: flex;
      justify-content: center;
      align-items: flex-start;
      img {
        width: 20px;
        height: 20px;
      }
    }
    .content {
      flex: 1;
      padding-left: 10px;
      .header {
        display: flex;
        .name-box {
          flex: 1;
          padding-right: 20px;
          .name {
            font-size: 16px;
            line-height: 16px;
          }
          .required {
            font-size: 16px;
            color: #ff5a60;
          }
        }
      }
      .attention-box {
        margin-top: 20px;
      }
      .memo {
        margin-top: 20px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/upload/upload-papery-material.vue